export const carMaterialConfig = {
    fennec: {
        hasExtraColor: false,
        // changeBodyUV: false
    },
    octane: {
        hasExtraColor: false,
        // changeBodyUV: false
    },
    dominus: {
        hasExtraColor: true,
        // changeBodyUV: false
    }
}